import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreateGuardForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createGuard, loadGuards = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  return (
    <>
      <label>Сотрудник</label>
      <input
        placeholder="Поиск сотрудника..."
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">— Выберите сотрудника —</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{emp.label}</option>
        ))}
      </select>

      <label>Телефон</label>
      <input placeholder="Телефон" value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={async () => {
          try {
            await createGuard(modalPayload)
            await loadGuards()
            closeModal()
            notifySuccess('Охранник создан')
          } catch (err) { console.error(err); notifyError(err, 'Не удалось создать охранника') }
        }} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreateGuardForm
